import * as React from 'react';

import { RootState } from '../store';

import { Dispatch, Action } from 'redux';
import { UPDATE_FORM, SUBMIT_LOGIN } from '../store/login';
import { returntypeof } from '../helper';
import { connect } from 'react-redux';


const mapStateToProps = (state: RootState) => ({
    login: state.login
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
    onChange: (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch({
            type: UPDATE_FORM,
            field: field,
            value: event.currentTarget.value
        })
    },
    onSubmit: () => {
        dispatch({type: SUBMIT_LOGIN})
    }
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps;

type State = {}

class Login extends React.Component<Props, State> {

    onKeyPress = (e: React.KeyboardEvent<any>) => {

        if(e.key === "Enter") {
            this.props.onSubmit()
        }
    }

    inIframe = () => {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    public render() {
        let logo;
        if(!this.inIframe()){
            logo = <p className="float-left"><img src="/api/asset/logo" alt="" width="180px" height="auto"></img></p>
        }

        let className = "form-control";
        let errorText;
        if(this.props.login.failed){
            className += " is-invalid";
            errorText = <p style={{color: 'red', paddingLeft: '15px'}}>Username or password was incorrect.</p>
        }

        return (
            <div className="signUp-page signUp-standard pt-90">
                <div className="signUp-illustration">
                    <img src="/assets/icons/portal_1.jpg"></img>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 ml-auto">

                            <div className="signin-form-wrapper">

                                <div className="title-area">
                                    <div className="row">
                                        <div className="col-12">
                                            {logo}
                                        </div>
                                        <div className="col-12">
                                            <h3 className="h4"> Login to <br/> Portal&trade;</h3>
                                        </div>
                                    </div>
                                </div>

                                <form id="login-form">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="input-group">
                                                <input type="text" id="username" value={this.props.login.username || ""} onChange={this.props.onChange("username")} required />
                                                    <label>Username or Email</label>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="input-group" onKeyDown={this.onKeyPress}>
                                                <input type="password" id="password" value={this.props.login.password || ""} onChange={this.props.onChange("password")} required/>
                                                <label>Password</label>
                                                {errorText}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                
                                <button className="solid-button-one"  onClick={this.props.onSubmit}>Login</button>

                                <p className="mt-70 float-right small">Powered by <img src="/assets/icons/logo.jpg" alt="" width="120px" height="auto" /> <p className="mt-10 float-right small">v.{process.env.REACT_APP_VERSION == undefined ? "0.9.0" : process.env.REACT_APP_VERSION }</p></p>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default connect(mapStateToProps, mapDispatchToProps)(Login);